import React from 'react';
import './style/ImageWithFadeIn.css';
import { noticeError } from 'app/api/analytics/reporting';

export default class MonitoredImage extends React.PureComponent {
  boundOnError = this.onError.bind(this);

  onError(e) {
    noticeError(`Missing Image: ${this.props.src} or ${this.props.srcSet}`);
    if (this.props.onError) {
      this.props.onError(e);
    }
  }

  render() {
    const { onError, ...restProps } = this.props;

    return (
      // Provided by restProps
      // eslint-disable-next-line jsx-a11y/alt-text
      <img {...restProps} onError={this.boundOnError} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/ui/core/common/MonitoredImage.js